<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { contentAttributes } = useMessageContext();

const data = computed(() => contentAttributes.value?.data || {});
const options = computed(() => data.value.options || []);
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="evolution-poll">
    <div class="flex flex-col gap-2">
      <div class="flex items-center gap-1.5">
        <span class="i-ph-chart-bar size-4 shrink-0" />
        <p class="font-medium mb-0">{{ data.question }}</p>
      </div>
      <div class="flex flex-col gap-1.5 mt-1">
        <div
          v-for="(option, index) in options"
          :key="index"
          class="px-3 py-1.5 rounded-lg bg-n-alpha-1"
        >
          {{ option }}
        </div>
      </div>
    </div>
  </BaseBubble>
</template>
